import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect } from "react";

const MODAL_KEY = "acquapark_welcome_modal";
const MODAL_DURATION = 60 * 60 * 1000; // 1 hora em milliseconds

export default function WelcomeModal() {
  const { onOpen, onClose } = useDisclosure();

  useEffect(() => {
    const modalData = localStorage.getItem(MODAL_KEY);

    if (!modalData) {
      onOpen();
      return;
    }

    const { timestamp } = JSON.parse(modalData);
    const now = Date.now();

    if (now - timestamp > MODAL_DURATION) {
      localStorage.removeItem(MODAL_KEY);
      onOpen();
    }
  }, [onOpen]);

  const handleClose = () => {
    localStorage.setItem(MODAL_KEY, JSON.stringify({ timestamp: Date.now() }));
    onClose();
  };

  return (
    <Modal isOpen={false} onClose={handleClose} isCentered>
      <ModalOverlay />
      <ModalContent mx={4}>
        <ModalHeader>⚠ Aviso Importante</ModalHeader>
        <ModalCloseButton onClick={handleClose} />
        <ModalBody pb={6}>
          <VStack spacing={4} align="start">
            <Text fontSize="lg">
              Estamos enfrentando instabilidade em nosso número oficial de WhatsApp.
              Por isso, estaremos atendendo temporariamente pelo WhatsApp:
            </Text>
            <Text fontSize="2xl" fontWeight="bold" color="green.500" textAlign="center" w="full">
              (65) 9 9942-1276
            </Text>
            <Text fontSize="lg">
              A equipe do ÁCQUA PARK PANTANAL continua à disposição para ajudar você! 💦🌴
            </Text>
            <Button colorScheme="blue" onClick={handleClose} w="full" size="lg">
              Fechar
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}